export default __webpack_public_path__ + "static/media/product-24.de082d75.jpg";